import { render, staticRenderFns } from "./SharedOrderDetail.vue?vue&type=template&id=f9e8b176&scoped=true&"
import script from "./SharedOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SharedOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SharedOrderDetail.vue?vue&type=style&index=0&id=f9e8b176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e8b176",
  null
  
)

export default component.exports